import React from "react";

const PrivacyPolicy = () => {
  const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');

    body {
        background-color: #FFEDE3;
        margin: 0;
        padding: 0;
        min-height: 100vh;
        width: 100%;
    }

    .policy-container {
      font-family: 'Poppins', Arial, sans-serif;
      padding: 60px 20px;
      max-width: 900px;
      margin: 0 auto;
      color: #333;
    }

    .policy-header {
      text-align: center;
      margin-bottom: 40px;
      margin-top: 5rem;
    }

    .policy-header h1 {
      font-size: 2.5em;
      font-weight: 700;
      color: #ff6600;
      margin-bottom: 5px;
    }

    .policy-header p {
      color: #666;
      max-width: 600px;
      margin: 0 auto;
      font-size: 1em;
    }

    .policy-section {
      margin-bottom: 30px;
    }

    .policy-section h2 {
      font-size: 1.8em;
      font-weight: 600;
      color: #ff6600;
      margin-bottom: 15px;
      border-bottom: 2px solid #ff6600;
      padding-bottom: 5px;
      display: inline-block;
    }

    .policy-section ul {
      list-style-type: none;
      padding-left: 0;
    }

    .policy-section li {
      margin-bottom: 10px;
      line-height: 1.6;
    }

    .policy-section li strong {
      font-weight: 600;
    }
    
    .go-back-button {
      background-color: #f97316;
      color: white;
      padding: 1rem 2rem;
      font-size: 1.1em;
      border: none;
      border-radius: 2rem;
      cursor: pointer;
      font-weight: 600;
      display: block;
      margin: 40px auto 0;
      box-shadow: 0 4px 15px rgba(249, 115, 22, 0.3);
      transition: all 0.3s ease;
    }

    .go-back-button:hover {
      background-color: #ea580c;
      transform: scale(1.05);
      box-shadow: 0 6px 20px rgba(234, 88, 12, 0.4);
    }
  `;

  return (
    <div className="policy-container">
      <style>{styles}</style>
      <div className="policy-header">
        <h1>Privacy Policy</h1>
        <p>
          At TIFFO Foods, we value your trust and are committed to protecting
          your privacy. This policy explains how we collect, use, and safeguard your information.
        </p>
      </div>

      <div className="policy-section">
        <h2>1. Information We Collect</h2>
        <ul>
          <li><strong>Personal details:</strong> name, phone number, email, and delivery address.</li>
          <li>
            <strong>Payment details:</strong> processed securely by our payment partners (Razorpay/UPI/Card/Wallet). We do not store your card or UPI information.
          </li>
          <li>
            <strong>App usage data:</strong> order history, preferences, and feedback to improve our services.
          </li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>To process and deliver your orders accurately and on time.</li>
          <li>To provide updates on order status and delivery through the app, WhatsApp, or SMS.</li>
          <li>To improve our menu, services, and customer experience.</li>
          <li>To communicate offers, promotions, or important updates (you can opt-out anytime).</li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>3. Data Protection & Security</h2>
        <ul>
          <li>All payments are processed via secure, PCI-DSS compliant gateways.</li>
          <li>Personal information is stored securely and is not sold, rented, or shared with third parties, except for delivery and legal requirements.</li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>4. Sharing of Information</h2>
        <ul>
          <li>Data may be shared only with trusted service providers (e.g., delivery staff, payment gateways) strictly for fulfilling your orders.</li>
          <li>We do not sell or misuse customer data for advertising without consent.</li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>5. Your Rights</h2>
        <ul>
          <li>You may request corrections, updates, or deletion of your personal data by contacting us.</li>
          <li>You may also choose to unsubscribe from promotional communications at any time.</li>
        </ul>
      </div>

      <div className="policy-section">
        <h2>6. Legal Compliance</h2>
        <ul>
          <li>TIFFO Foods complies with applicable Indian laws, including the Information Technology Act, 2000 and data protection rules.</li>
        </ul>
      </div>

      <button className="go-back-button" onClick={() => window.history.back()}>
        Go Back Before You Get Hungry
      </button>

    </div>
  );
};

export default PrivacyPolicy;